const KeenSlider = window.KeenSlider

const { setInitialised, useArrows } = window.BAO.Carousel.plugins

class SizeGuideSlider extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()

    this.bindSlideChange()
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: false,
        mode: 'snap',
        origin: 'center',
        initial: 0, // 👈 change this (important)
        slides: {
          origin: 'center',
          perView: 1.8,
          spacing: 0,
        }
      },
      [
        setInitialised(),
        useArrows({
          container: this.els?.arrows?.element,
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        })
      ],
    )
  }

  bindSlideChange() {
    if (!this.carousel) return;

    this.carousel.on('slideChanged', () => {
      const index = this.carousel.track.details.rel;
      const slide = this.els.slides.element.querySelectorAll('[data-size-guide-slider-el="slide"]')[index];

      if (!slide) return;

      const json = slide.dataset.json;
      const image = slide.dataset.mainImage;

      let data;

      try {
        data = JSON.parse(json);
      } catch (e) {
        console.warn('Invalid JSON in slide', e);
        return;
      }

      const sizeGuide = this.closest('size-guide');

      if (!sizeGuide || !sizeGuide.setActiveFromData) return;

      sizeGuide.updateContentWithFade({
        ...data,
        main_image: image
      });
    });
  }
}

customElements.define('size-guide-slider', SizeGuideSlider);
